import { render, staticRenderFns } from "./DirectDebitInfoText.vue?vue&type=template&id=80f362a8&"
import script from "./DirectDebitInfoText.vue?vue&type=script&lang=js&"
export * from "./DirectDebitInfoText.vue?vue&type=script&lang=js&"
import style0 from "./DirectDebitInfoText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports